import styled from 'styled-components';
import FlexWrap from '@/components/common/FlexWrap';
import { GUIDE_STEPS } from '@repo/constants';
import { IMG_LOGO_KTP_WHITE, IMG_QRCODE } from '@repo/assets';

function Notification() {
  return (
    <Container dir='column' flex='1' justifyContent='space-between'>
      <div>
        <Title>
          택스리펀 안내 <EngTitle>Tax Refund Procedure</EngTitle>
        </Title>
        {GUIDE_STEPS.koreanText.map((item, index) => (
          <FlexWrap key={index} dir='column'>
            <SubTitle>{item.title}</SubTitle>
            <Description>{item.description}</Description>
          </FlexWrap>
        ))}
        {GUIDE_STEPS.englishText.map((item, index) => (
          <FlexWrap key={index} dir='column'>
            <SubTitle>{item.title}</SubTitle>
            <Description>{item.description}</Description>
          </FlexWrap>
        ))}
      </div>
      <div>
        <FlexWrap gap='20px' margin='20px 0'>
          <div>
            <QrGuideTitle>{GUIDE_STEPS.qrGuideText.title}</QrGuideTitle>
            <QrGuideDesceiption>
              {GUIDE_STEPS.qrGuideText.description}
            </QrGuideDesceiption>
          </div>
          <QrImage src={IMG_QRCODE} />
        </FlexWrap>
        <LogoImage src={IMG_LOGO_KTP_WHITE} />
      </div>
    </Container>
  );
}
const Container = styled(FlexWrap)`
  padding: 30px;
  background-color: #f5f6f7;
`;

const Title = styled.h1`
  font-size: 28px;
  color: #1856cd;
  font-weight: 600;
  margin-bottom: 24px;
`;
const EngTitle = styled(Title)`
  font-size: 16px;
  font-weight: 600;
  display: inline;
`;
const SubTitle = styled.h2`
  font-size: 16px;
  margin-bottom: 12px;
  font-weight: 600;
`;
const Description = styled.p`
  color: #3a3b3e;
  font-size: 12px;
  font-weight: 500;
  line-height: 150%;
  margin-bottom: 18px;
`;
const QrGuideTitle = styled.h3`
  font-size: 15px;
  font-weight: 700;
  line-height: 150%;
  margin-bottom: 4px;
`;
const QrGuideDesceiption = styled.p`
  font-size: 11px;
  line-height: 150%;
`;
const QrImage = styled.img`
  width: 75px;
  height: 75px;
`;
const LogoImage = styled.img`
  display: block;
  width: 100px;
  margin: 0 auto;
`;

export default Notification;
